import React from 'react';
import { Spin, Icon, Modal, Button, message, Pagination, Empty } from 'antd';
import ModalDom from '../../components/Modal';
import { postFrom, config  } from '../../axios/index';
import moment from 'moment';

export default class ActionRecords extends React.Component {
    constructor() {
        super();
        this.state = {
            actionVisible: false,
            loading: false,
            data: [],
            newData: [],
            params: {
                rowId: "",
                tableName: "",
            },
            pageSize: 10,
            current: 1
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    queryActionRecords = ({rowId, tableName}) => { //操作记录

        this.setState({ actionVisible: true, loading: true });

        let { params, current, pageSize } = this.state;
        let data = Object.assign({}, params, { current, rowId, tableName, pageSize });

        postFrom({
            url: config.API_operationlog_findOperationLogListPage,
            data,
        }).then(res => {
            let firstData = res.records.slice(0, pageSize);
            this.setState({ current: res.current, data: res.records, newData: firstData, loading: false });
        }).catch(err => {
            message.error(err.message || '获取操作记录失败');
            this.setState({ loading: false });
        });
    }

    onChange = page => { //改变分页
        let { data, newData, pageSize } = this.state;
        newData = data.slice((page - 1) * pageSize); //截取当前页所需要的数据
        if (newData.length > pageSize) { //如果当前页的数据大于展示最大条数
            newData = newData.slice(0, pageSize);
        }
        this.setState({ current: page, newData })
    };


    render() {
        let { handleCancel, visible } = this.props;
        let { loading, data, newData  } = this.state;

        return (
            <ModalDom
            title="操作记录"
            visible={visible}
            loading={loading}
            onCancel={handleCancel}
            width={"800px"}
            footer={
                <div>
                     <Button onClick={handleCancel}>关闭</Button>
                </div>
            }
        >
            {
                newData.length !== 0 ?
                <div className="custom">
                <div className="tableBox" >
                    <div className="tableTitle">
                        <div style={{ flex: 1 }}>操作时间</div>
                        <div style={{ flex: 1 }}>操作名称</div>
                        <div style={{ flex: 1 }}>部门</div>
                        <div style={{ flex: 1 }}>人员</div>
                    </div>
                    <div className="tableBody">
                        {
                            newData.map((item, index) => {
                                return (
                                    <div className="tableBodyRow" key={index}>
                                    <div style={{ flex: 1 }}>
                                        { item.createTime ? moment(item.createTime).format("YYYY-MM-DD") : null}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        { item.comment ? item.comment : null}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        { item.departmentName ? item.departmentName : null}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        { item.operatorName ? item.operatorName : null}
                                    </div>
                                </div>
                                )
                                
                            })
                        }
                       
                    </div>
                </div>
            </div>
            : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }
            {
                data.length !== 0 ?
                <div style={{ padding: '10px 0', textAlign: 'right' }}>
                        <Pagination 
                        size="small"
                        current={this.state.current}
                        pageSize={10}
                        onChange={this.onChange}
                        total={data.length}
                    />
                    </div>
                    : null
            }

        </ModalDom>
        )
    }
}


// WEBPACK FOOTER //
// ./src/page/ActionRecords/index.jsx